import cookie from 'js-cookie';

import { log } from '~/utils/log';
import { getPageViewId } from '~/utils/navigationContext';

import { enqueueImpression } from './impressionQueue';

const SCHEMA_VERSION = 1;

export type ImpressionType = 'product_card';

export type ImpressionServerEvent<T = Record<string, unknown>> = {
  data: {
    client_ts: number;
    guest_id?: string;
    impression_properties: T;
    impression_type: ImpressionType;
    schema_version: number;
    view_id: string;
  };
  type: 'impression';
};

type BaseData = {
  isBot: boolean;
};

abstract class ImpressionEvent<
  D extends BaseData = BaseData,
  T extends Record<string, unknown> = Record<string, unknown>
> {
  constructor(protected data: D) {}

  protected abstract get impressionType(): ImpressionType;

  track() {
    if (this.data.isBot) return;

    const event = this.buildEvent();

    if (!event) return;

    enqueueImpression(event);
  }

  private buildEvent(): ImpressionServerEvent<T> | undefined {
    const viewId = getPageViewId();

    if (!viewId) {
      log.error('ImpressionEvent fired without a view_id', {
        impression_type: this.impressionType
      });

      return;
    }

    return {
      data: {
        client_ts: Date.now(),
        guest_id: cookie.get('clickRefUid'),
        impression_properties: this.getImpressionProperties(),
        impression_type: this.impressionType,
        schema_version: SCHEMA_VERSION,
        view_id: viewId
      },
      type: 'impression'
    };
  }

  protected abstract getImpressionProperties(): T;
}

export default ImpressionEvent;
